import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginModalComponent } from './login-modal/login-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [LoginModalComponent],
  imports: [
      CommonModule,
      ReactiveFormsModule,
      TranslateModule,
      SharedModule
    ],
    exports: [
      ReactiveFormsModule,
      TranslateModule
    ]
})
export class ModalsModule { }
